import { useLocalStorage } from 'react-use';
import { useEffect } from 'react';
import { readPendingUserAccountItem } from '@pkgs/components/utils/readPendingUserAccountItem';
import { type PendingUserAccountItem, PendingUserAccountItemType } from '@pkgs/components/types/types';
import { PENDING_USER_ACCOUNT_ITEM_KEY } from '@pkgs/components/consts/consts';
import { useAuth } from '@ev-tech/user-account-modules';

export const usePendingUAExclusiveExposeAfterAuth = (isUserAccountModalOpen: boolean): void => {
  const { isLoaded, isSignedIn } = useAuth();
  const [, , removePendingItemToSave] = useLocalStorage<PendingUserAccountItem | null>(PENDING_USER_ACCOUNT_ITEM_KEY);

  useEffect(() => {
    if (!isLoaded || !isSignedIn || isUserAccountModalOpen) return;

    const pendingItem = readPendingUserAccountItem();

    if (pendingItem?.type !== PendingUserAccountItemType.UA_EXCLUSIVE_EXPOSE || !pendingItem.uAExclusiveAuthExposeUrl) {
      return;
    }

    const { uAExclusiveAuthExposeUrl } = pendingItem;
    removePendingItemToSave();
    window.location.assign(uAExclusiveAuthExposeUrl);
  }, [isLoaded, isSignedIn, isUserAccountModalOpen, removePendingItemToSave]);
};
